import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * Which certification of the day this is: a driver may certify a log several times, and the ELD counts them.
 *
 * Strings rather than numbers because the vendor's count is an enumeration with a ceiling, not a quantity: the ninth
 * and every later certification arrive as one value, so "9+" is a member and not a bound.
 */
export const CertificationOfDaySchema = z
  .enum(["1", "2", "3", "4", "5", "6", "7", "8", "9+"])
  .openapi("CertificationOfDay");

export type CertificationOfDay = z.infer<typeof CertificationOfDaySchema>;

/**
 * The driver certified a day's log.
 */
export const logCertifiedV1 = tmsEventKind(
  { category: "compliance", kind: "logCertified", version: 1 },
  { refs: dutyStatusChangeRefs, facts: { certificationOfDay: CertificationOfDaySchema } },
);

export const LogCertifiedV1Schema = logCertifiedV1.schema;
export const LogCertifiedV1FactsSchema = logCertifiedV1.facts;

export type LogCertifiedV1 = z.infer<typeof LogCertifiedV1Schema>;
export type LogCertifiedV1Facts = z.infer<typeof LogCertifiedV1FactsSchema>;

/** Every version of `logCertified`, keyed by version. What `catalog.ts` places under `compliance`. */
export const logCertified = { 1: logCertifiedV1 } as const;
